import styled from 'styled-components';
import { getColor } from 'utils';

export const AppContainer = styled('div')`
  background-color: ${props => getColor(props, 'primary')};
`;